import { BsTeacherManagementInvitingTable } from './BsTeacherManagementInvitingTable';
export default BsTeacherManagementInvitingTable;
